var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_118",
    "data-name": "Group 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 140,
    height: 140,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M70,0A70,70,0,1,1,.041,70,69.981,69.981,0,0,1,70,0",
    fill: "#26394c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M70,0A70,70,0,1,1,0,70,70,70,0,0,1,70,0",
    fill: "#1a1818",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M64.552,81.688a10.771,10.771,0,0,0-9.388,10.228c0,4.526,1.818,8.311,5.851,10.426a10.687,10.687,0,0,0,3.954,1.054h32.75a10.361,10.361,0,0,0,4.8-1.25,11.456,11.456,0,0,0,3.6-2.665c8.542-8.511,2.19-22.8-8.813-22.8H95.424c-.057-2.592-2.791-6.592-4.936-8.417A15.644,15.644,0,0,0,65.5,74.5c-.946,2.412-.949,3.951-.949,7.19",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M64.552,81.688a10.771,10.771,0,0,0-9.388,10.228c0,4.526,1.818,8.311,5.851,10.426a10.687,10.687,0,0,0,3.954,1.054h32.75a10.361,10.361,0,0,0,4.8-1.25,11.456,11.456,0,0,0,3.6-2.665c8.542-8.511,2.19-22.8-8.813-22.8H95.424c-.057-2.592-2.791-6.592-4.936-8.417A15.644,15.644,0,0,0,65.5,74.5c-.946,2.412-.949,3.951-.949,7.19",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M54.747,82.106c.218-2.61,3.5-4.907,5.216-6.053a16.157,16.157,0,0,1,3.721-11.1c1.871-2.284,5.749-5.739,9-5.811-.618-2.317-6.732-5.427-10.847-5.427a14.619,14.619,0,0,0-10.046,3.515c-6.462,5.226-7.283,15.781-.856,22.212.774.774,2.7,2.4,3.808,2.659",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M54.747,82.106c.218-2.61,3.5-4.907,5.216-6.053a16.157,16.157,0,0,1,3.721-11.1c1.871-2.284,5.749-5.739,9-5.811-.618-2.317-6.732-5.427-10.847-5.427a14.619,14.619,0,0,0-10.046,3.515c-6.462,5.226-7.283,15.781-.856,22.212.774.774,2.7,2.4,3.808,2.659",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 11.682,
    height: 3.548,
    transform: "translate(29.924 67.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 11.682,
    height: 3.548,
    transform: "translate(29.924 67.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 3.337,
    height: 11.479,
    transform: "translate(59.963 36.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 3.337,
    height: 11.479,
    transform: "translate(59.963 36.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M39.52,88.367l2.34,2.458A32.6,32.6,0,0,0,45.2,87.584c.75-.75,3.06-2.756,3.285-3.6l-2.244-2.346c-.539.372-4.367,4.167-5.107,5.009a7.083,7.083,0,0,1-1.618,1.721",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M39.52,88.367l2.34,2.458A32.6,32.6,0,0,0,45.2,87.584c.75-.75,3.06-2.756,3.285-3.6l-2.244-2.346c-.539.372-4.367,4.167-5.107,5.009a7.083,7.083,0,0,1-1.618,1.721",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M39.52,49.127c1.385.929,4.808,5.428,6.675,6.68a7.575,7.575,0,0,0,1.2-1.1c.507-.5.906-.709,1.093-1.41L42.074,46.78c-.74.235-.866.54-1.357,1.041a8.765,8.765,0,0,0-1.2,1.306",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M39.52,49.127c1.385.929,4.808,5.428,6.675,6.68a7.575,7.575,0,0,0,1.2-1.1c.507-.5.906-.709,1.093-1.41L42.074,46.78c-.74.235-.866.54-1.357,1.041a8.765,8.765,0,0,0-1.2,1.306",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M74.356,53.511,76.6,55.857l6.777-6.678-2.3-2.4c-1.159.36-2.5,2.393-3.437,3.34a34.058,34.058,0,0,0-3.288,3.39",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M74.356,53.511,76.6,55.857l6.777-6.678-2.3-2.4c-1.159.36-2.5,2.393-3.437,3.34a34.058,34.058,0,0,0-3.288,3.39",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/weather-icon.75a9ecb59886d086142c3861adb3ed85.svg";
export { ForwardRef as ReactComponent };